<template>
  <div class="cover" v-if="loading">
    <div class="mb-m">
      <smd-loading-spinner/>
    </div>
    <p>Fetching your doctors...</p>
  </div>
  <smd-one-col-layout class="doctors-list"
                      v-else
                      :content-styles="contentStylesClass">
    <section v-if="doctorsList.length && !loading">
      <div v-for="doctor in doctorsList"
           :key="doctor.id"
           @click="viewDoctor(doctor)"
           class="doctor smd-panel">
        <div class="image">
          <smd-profile-img :image="doctor.profile_url"/>
        </div>
        <div class="details">
          <p class="name">{{ doctor._fullName }}</p>
          <p class="specialty">{{ doctor.mainspecialty }}</p>
          <smd-btn section="4"
                   variant="blue-enabled"
                   @click.stop="book(doctor)">
            <span class="Button2">BOOK</span>
          </smd-btn>
        </div>
      </div>
    </section>
    <div class="cover" v-if="!doctorsList.length && !loading">
      <empty-state type="doctors"/>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {GETTER_DOCTORS_BY_ID} from '@/store/types';
  import {
    DOCTOR_ROUTE,
    DOCTOR_ROUTE_PARAM,
  } from '@/router/routes';
  import {bookDoctor} from '@/utils';
  import EmptyState from '@/components/empty-state';

  export default {
    name: 'doctors-list',
    components: {
      EmptyState,
    },
    data() {
      return {
        loading: false,
      }
    },
    computed: {
      ...mapGetters({
        doctors: GETTER_DOCTORS_BY_ID,
      }),
      contentStylesClass() {
        return [{'dark-light-bg': !this.$isMobile}, 'doctors-list__content-style']
      },
      doctorsList() {
        if (!this.doctors) return [];
        return Object.keys(this.doctors).map((doctorId) => this.doctors[doctorId]);
      },
    },
    watch: {
      doctors: {
        handler(value) {
          if (value === null) {
            this.loading = true;
          } else {
            this.loading = false;
          }
        },
        immediate: true,
      },
    },
    methods: {
      viewDoctor(doctor) {
        this.$router.push({
          name: DOCTOR_ROUTE,
          params: {
            [DOCTOR_ROUTE_PARAM]: doctor.usertag,
          },
        });
      },
      book(doctor) {
        bookDoctor(doctor.usertag);
      },
    },
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .doctors-list {
    .doctor {
      display: flex;
      padding: space(m);
      border-radius: radius(medium);
      background-color: color(base, background);
      cursor: pointer;

      &:not(:last-child) {
        margin-bottom: space(m);
      }

      .image {
        margin-right: space(m);
      }

      .details {
        .name {
          font-size: font(m);
          font-weight: font(bold);
        }

        .specialty {
          margin-bottom: space(s);
        }
      }
    }

    .list-empty {
      text-align: center;
      color: color(label, text);

      img {
        margin-bottom: space(l);
      }

      p {
        margin-bottom: space(m);

        &:first-child {
          font-weight: bold;
          margin-bottom: space(l);
          color: color(base, text);
        }
      }

      span {
        font-weight: 500;
      }
    }
  }

  .doctors-list__content-style {
    > div {
      @include set-max-width($max-width: 1583px);
    }

    @include responsive('min-width: 1024px') {
      padding: space(xxl) !important;

    }
  }
</style>
